"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextReferenceResolver = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _util = require("./util");
var _ContextManager = require("./ContextManager");
var _value2 = require("./value");
var _ErrorValueTypeHandler = require("./value/type/ErrorValueTypeHandler");
var _types = require("./value/types");
class ContextReferenceResolver {
  constructor(context) {
    (0, _defineProperty2.default)(this, "tracking", []);
    this.context = context;
  }
  trackLayer(self) {
    this.tracking.unshift({
      self,
      indexes: new Set()
    });
  }
  endTrack() {
    let layer = this.tracking.shift();
    if (this.tracking.length > 0) {
      let parent = this.tracking[0].indexes;
      for (let it of layer.indexes) {
        parent.add(it);
      }
    }
    return Array.from(layer.indexes);
  }
  basicResolve(ref) {
    let resolver = _ContextManager.resolvers[ref.type];
    let resolved = resolver.resolve(this.context, ref.param);
    if (!(resolved !== null && resolved !== void 0 && resolved.value)) {
      return {
        type: "error",
        value: new _ErrorValueTypeHandler.ValueTypeError("invalid_reference", "Invalid reference")
      };
    }
    return _types.vals.path(resolved.value, resolved.path);
  }
  resolveReference(ref) {
    let resolver = _ContextManager.resolvers[ref.type];
    return resolver.resolveReference(this.context, ref.param);
  }
  resolve(ref) {
    if (!ref) {
      return {
        type: "error",
        value: new _ErrorValueTypeHandler.ValueTypeError("invalid_reference", "Invalid reference")
      };
    }
    if ((0, _util.isVariableReference)(ref)) {
      let resolver = _ContextManager.resolvers[ref.type];
      if (this.tracking.length > 0) {
        let resolved = resolver.resolveReference(this.context, ref.param);
        if (!(resolved !== null && resolved !== void 0 && resolved.value)) {
          return {
            type: "error",
            value: new _ErrorValueTypeHandler.ValueTypeError("invalid_reference", "Invalid reference")
          };
        }
        if (resolved.value instanceof _value2.VariableReference) {
          let varRef = resolved.value;
          let cyclic = this.tracking.find(it => it.self === varRef.index);
          if (cyclic) {
            throw new Error(`Cyclic variable reference found (index: ${cyclic.self}), a variable can't depend on itself!`);
          }
          this.tracking[0].indexes.add(varRef.index);
        }
        let path = resolved.path;
        let value = resolved.value.value();
        return _types.vals.path(value, path);
      } else {
        return this.basicResolve(ref);
      }
    } else {
      return this.basicResolve(ref);
    }
  }
  resolveString(ref) {
    return _types.vals.stringValue(this.resolve(ref));
  }
  resolveNumber(ref) {
    let value = this.resolve(ref);
    return _types.vals.numeric(value);
  }
  resolveContract(ref) {
    var _value;
    let value;
    if (ref) {
      value = this.resolve(ref);
    } else {
      value = this.resolve({
        type: "var",
        param: {
          type: "contract"
        }
      });
    }
    if (((_value = value) === null || _value === void 0 ? void 0 : _value.type) === "contract") {
      return value.value;
    }
    return null;
  }
  resolveWallet(ref) {
    let value;
    if (ref) {
      value = this.resolve(ref);
    } else {
      value = this.resolve({
        type: "var",
        param: {
          type: "wallet"
        }
      });
    }
    return _types.vals.address(value);
  }
  resolveArray(ref) {
    return _types.vals.array(this.resolve(ref));
  }
  resolveVariable(name) {
    return this.resolve({
      type: "var",
      param: {
        name
      }
    });
  }
  resolveValueVariable(name) {
    return _types.vals.value(this.resolveVariable(name));
  }
  resolveAbi(name) {
    return this.context.abis.get(name);
  }
  paletteParameter(name) {
    return this.context.apis.paletteParameters[name];
  }
  convertTypeRegistry() {
    return this.context.apis.convertTypes;
  }
  resolveCollectionItems(name) {
    let collected = this.context.findCollectionItems(name);
    return collected.map(info => {
      if (info.ref instanceof _value2.VariableReference) {
        return info.ref;
      }
      return null;
    }).filter(it => !!it);
  }
}
exports.ContextReferenceResolver = ContextReferenceResolver;
//# sourceMappingURL=ContextReferenceResolver.js.map